class WPVideo extends HTMLElement {
  /**
   * Tag name of element
   * @readonly
   * @static
   */
  static get is() {
    return 'wp-video';
  }

  /**
   * Getter for `playing` attribute
   */
  get playing() {
    return this.hasAttribute('playing') ? this.getAttribute('playing') : '';
  }

  /**
   * Setter for `playing` attribute
   */
  set playing(value) {
    if (Boolean(value)) {
      this.setAttribute('playing', '');
    } else {
      this.removeAttribute('playing');
    }
  }

  /**
   * Getter for `videosrc` attribute
   */
  get videosrc() {
    return this.hasAttribute('videosrc')
      ? 'https://www.youtube.com/embed/' + this.getAttribute('videosrc')
      : '';
  }

  /**
   * Setter for `videosrc` attribute
   */
  set videosrc(value) {
    if (value) {
      this.setAttribute('videosrc', value);
    } else {
      this.removeAttribute('videosrc');
    }
  }

  /**
   * Getter for `src` attribute
   */
  get src() {
    return this.hasAttribute('src') ? this.getAttribute('src') : '';
  }

  /**
   * Setter for `src` attribute
   */
  set src(value) {
    if (value) {
      this.setAttribute('src', value);
    } else {
      this.removeAttribute('src');
    }
  }

  /**
   * Getter for `srcset` attribute
   */
  get srcset() {
    return this.hasAttribute('srcset') ? this.getAttribute('srcset') : '';
  }

  /**
   * Setter for `srcset` attribute
   */
  set srcset(value) {
    if (value) {
      this.setAttribute('srcset', value);
    } else {
      this.removeAttribute('srcset');
    }
  }

  /**
   * Getter for `alt` attribute
   */
  get alt() {
    return this.hasAttribute('alt') ? this.getAttribute('alt') : '';
  }

  /**
   * Setter for `alt` attribute
   */
  set alt(value) {
    if (value) {
      this.setAttribute('alt', value);
    } else {
      this.removeAttribute('alt');
    }
  }

  /**
   * Getter for `caption` attribute
   */
  get caption() {
    return this.hasAttribute('caption') ? this.getAttribute('caption') : '';
  }

  /**
   * Setter for `caption` attribute
   */
  set caption(value) {
    if (value) {
      this.setAttribute('caption', value);
    } else {
      this.removeAttribute('caption');
    }
  }

  get template() {
    const caption = this.caption
      ? `
      <figcaption class="c-caption">
        <i class="c-caption__icon icon-logo-shapes-horizontal">
          <svg aria-hidden="true" width="102" height="17">
            <use xlink:href="/wp-content/themes/genv/static/dist/svg/symbols.svg#logo-shapes-horizontal" />
          </svg>
        </i>
        ${this.caption}
      </figcaption>
    `
      : '';

    const image =
      this.srcset || this.src
        ? `
      <figure class="c-image c-video__img ">

        <wp-img 
          src="${this.src}" 
          srcset="${this.srcset}" 
          alt="${this.alt}"
          fit="cover">
          <noscript>
            <img 
            class="u-object-fit" 
            style="opacity:1" 
            src="${this.src}" 
            alt="<${this.alt}">
          </noscript>
        </wp-img>

      </figure>
    `
        : '';

    const button =
      this.srcset || this.src
        ? `
      <button class="c-video__button screen">
        Play me
      </button>   
      <div class="c-video__overlay"></div>
    `
        : '';

    return `
      <div 
        class="o-ratio o-ratio--16x9"
        data-sal="fadeIn"
        >

        <iframe frameborder="0"></iframe>

        ${image}

        ${button}
        
      </div>

      ${caption}
    `;
  }

  /**
   * Lifecycle event when element is attached to DOM
   */
  connectedCallback() {
    // If no video src attribute defined, return
    if (!this.videosrc) {
      return;
    }

    this.classList.add('c-video');
    this.innerHTML = this.template;

    this._video = this.querySelector('iframe');
    this._button = this.querySelector('button');

    if (this._button) {
      this._button.addEventListener('click', () => {
        this.playing = true;
        this._play();
      });
    } else {
      this._video.src = this.videosrc;
    }
  }

  _play() {
    this._video.src = this.videosrc + '?autoplay=1';
  }
}

customElements.define(WPVideo.is, WPVideo);
